import { parseNoteRef } from "@plannello/shared";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { GlobalNotesPage } from "@/components/notes/NotesPages";

/**
 * /notes/12/port-registry: a global note. Also the short, move-proof link to any note (/notes/12): product notes
 * move on to their canonical URL under /p/KEY/notes. `?edit=1` opens the editor (right after creating).
 */
export const Route = createFileRoute("/_app/notes/$ref/{-$slug}")({
  validateSearch: (s: Record<string, unknown>): { edit?: "1" } => (s.edit === "1" || s.edit === 1 ? { edit: "1" } : {}),
  beforeLoad: ({ params }) => {
    if (!parseNoteRef(params.ref)) throw notFound();
  },
  component: View,
});

function View() {
  const { ref, slug } = Route.useParams();
  const { edit } = Route.useSearch();
  return <GlobalNotesPage refNum={parseNoteRef(ref) ?? undefined} slug={slug} edit={edit === "1"} />;
}
